import { PBXExtensions } from "./pbx_extensions";
import { PBXCallFlowTreatments } from "../pbx_treatments/pbx_call_flow_treatments";
import { CallTreatmentsList } from "../treatments/call_treatments_list";
import { PBXNumbers } from "./pbx_numbers";

export class PhoneManagement extends HTMLElement {
  constructor(data, is_admin) {
    super();
    this.group_id = data;
    this.is_admin = is_admin;
  }

  async connectedCallback() {
    let res = await fetch(`/admin/groups/${this.group_id}/pbx`);
    let json = await res.json();
    this.pbx_status = json.exists;
    console.log(this.pbx_status)
    this.innerHTML =
    `
    <style>
      #tablist_phone_management {
        margin: 0 0 20px 0 !important;
        border: none !important;
      }
      .slide_adjust_col_8 {
        width: 56vw;
      }
    </style>
    ${this.pbx_status ?
      `<div class="row">
        <div class="nav-secondary nav2-subtabs page-content-wrap nav" role="tablist" id='tablist_phone_management'>
          <a class="active" href="#pbx_setup_tab" role="tab" data-toggle="tab">Settings</a>
          <a href="#pbx_extensions_tab" role="tab" data-toggle="tab">Extensions</a>
          <a href="#pbx_numbers_tab" role="tab" data-toggle="tab">Numbers</a>
          <a href="#pbx_call_flow_tab" role="tab" data-toggle="tab">Call Flows</a>
          <a href="#pbx_app_store" role="tab" data-toggle="tab">App Store</a>
        </div>
        <div class="panel-body tab-content">
          <div class="page-content-wrap nav2-subtabs-item  tab-pane active" id="pbx_setup_tab">

          </div>
          <div class="page-content-wrap nav2-subtabs-item  tab-pane" id="pbx_extensions_tab">

          </div>
          <div class="page-content-wrap nav2-subtabs-item  tab-pane" id="pbx_numbers_tab">
            
          </div>
          <div class="page-content-wrap nav2-subtabs-item  tab-pane" id="pbx_call_flow_tab">
            
          </div>
          <div class="page-content-wrap nav2-subtabs-item  tab-pane" id="pbx_app_store">
            
          </div>
        </div>
        <audio-modal data-domain_id="${json.domain_id}"></audio-modal>
      </div>`
      :
      `<style>
        .phone_management_main {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 500px;
          background-image: linear-gradient(to right, rgba(255, 255, 255, 0.8) 0 100%), url(/assets/pbx_background.png);
          background-size: cover;
        }

        .phone_management_splash {
          width: 800px;
        }

        .heading1 {
          font-size: 24px;
          font-weight: bold;
          color: #434a54;
        }

        .splash_body{
          font-size: 14px;
          color: #6b6b6b;
          line-height: 1.42857143;
          margin: 16px 0px 20px 0px;
        }



      </style>
      <div class="phone_management_main">
        <div class="phone_management_splash">
          <span class="heading1">AutoID Phone Management</span>
          <br>
          <span class="splash_body">Enroll your company in the AutoID Phone Management System to create your business telephone network</span>
          <br>

          <button class="btn btn-success" id="pbx_enroll" style="margin-top: 32px">Enroll</button>
        </div>
      </div>`}
    `;

    if(this.pbx_status) {
      $(this).find(".nav2-subtabs a").on("click",function(e){
        $(this).find(".nav2-subtabs a").removeClass("active");
        $(e.target).addClass("active");
        $(this).find(".nav2-subtabs-item").removeClass("active");
        $($(e.target).attr("href")).addClass("active");
        return false;
      }.bind(this));
      
      this.querySelector('#pbx_setup_tab').appendChild(new PhoneManagementSetup(this.group_id, json.domain_id, json));
      this.querySelector('#pbx_extensions_tab').appendChild(new PBXExtensions(this.group_id, json.domain_id));
      this.querySelector('#pbx_numbers_tab').appendChild(new PBXNumbers(this.group_id, json.domain_id));
      this.querySelector('#pbx_call_flow_tab').appendChild(new CallTreatmentsList(json.domain_id, 'pbx', this.group_id));
    }

    if(!this.pbx_status) {
      this.querySelector('#pbx_enroll').addEventListener('click', async function() {
          if(await confirmPlus("Are you sure you want to setup a PBX?")){
          let result = await fetch(`/admin/groups/${this.group_id}/pbx`, {
            method: 'POST',
            headers: {
              'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
              'Content-Type': 'application/json'
            }
          })

          let response = await result.json();

          //Call success or failure callback
          if(result.ok && response.success) {
            Common.notify('Successfully set up Phone Management', 'success');
            this.connectedCallback();
          }
          else {
            Common.notify(response.message != null ? response.message : 'Failed to set up Phone Management.', 'error');
          }
        }
      }.bind(this))
    }
  }
}

customElements.define('phone-management', PhoneManagement)

class PhoneManagementSetup extends HTMLElement {
  constructor(group_id, domain_id, pbx_settings) {
    super();
    this.group_id = group_id;
    this.domain_id = domain_id;
    this.pbx_settings = pbx_settings;
  }

  async connectedCallback() {

    this.innerHTML =
      `
      <style>
        phone-management-setup input,
        phone-management-setup select {
          margin-bottom: 20px;
        }
      </style>
      <div class="row pbx_number_form">
        <div class="errors"></div>
        <div class="col-sm-7">
          <div class="number_name_options">
            <label>Default Call Flow</label>
            <select is=treatments-select class="form-control call_treatments_id" data-cy="call-treat-id" domain_id="${this.domain_id}" ${this.pbx_settings.default_campaign != null ? `data-selected="${this.pbx_settings.default_campaign.default_target_id}"` : ``}></select>
          </div>
        </div>

        ${this.pbx_settings.default_campaign == null || this.reset_did ? `
          <div class="col-sm-7">
            <label>Default Number: Select local or toll free number</label>
          </div>
          <pbx-number-picker data-required="true"></pbx-number-picker>
        ` : `
          <div class="col-sm-7">
            <label>Default Number</label>
          </div>
          <div class='col-sm-7'>
            <span>${this.pbx_settings.default_campaign.did.toString().replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')}</span>
            <button class="btn btn-outline-danger replace_number_did" style="margin-left: 12px">Replace</button>
          </div>
        `}

        <div class="col-sm-7">
          <label>Timezone</label>
          <select name="timezone" class="form-control" id="location-settings-timezone">
            <option value="US/Pacific" selected="">US/Pacific</option>
            <option value="US/Mountain" null="">US/Mountain</option>
            <option value="US/Central" null="">US/Central</option>
            <option value="US/Eastern" null="">US/Eastern</option>
          </select>
        </div>

        <div class="form-group col-sm-7 no-gutters" style="overflow:auto;">
          <a id="phone_management_setup_save" class='btn btn-primary pull-right detail-row-button'>Save</a>
          <a id="phone_management_setup_cancel" class='btn btn-outline-secondary pull-right detail-row-button'>Cancel</a>
        </div>
      </div>
      `;

    this.querySelector("#location-settings-timezone").value = this.pbx_settings.timezone;


    this.querySelector("#phone_management_setup_save").addEventListener("click", this.save.bind(this))
    this.querySelector("#phone_management_setup_cancel").addEventListener("click", this.cancel.bind(this))

    if(this.pbx_settings.default_campaign && !this.reset_did) {
      this.querySelector(".replace_number_did").addEventListener("click", this.replaceNumber.bind(this))
    }
  }

  async save() {
    if(this.validate()) {
      let data = {
        timezone: this.querySelector("#location-settings-timezone").value,
        target_id: this.querySelector(".call_treatments_id").value
      }

      if(this.reset_did || this.pbx_settings.default_campaign == null) {
        let phone_number = this.querySelector('pbx-number-picker').getData();
        data.npanxx = phone_number.npanxx
      }

      let res = await fetch(`/admin/groups/${this.group_id}/pbx/settings`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'POST',
        body: JSON.stringify(data)
      })

      let response = await res.json();
      if(response.success) {
        Common.notify('Phone Management Settings updated', 'success');
        this.reset_did = false;
        this.pbx_settings = response;
        this.connectedCallback();
      } else {
        this.querySelector('.errors').innerHTML = `<div class="alert alert-danger alert-dismissible" role="alert">
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                    <strong>Warning!</strong> Unable to save settings.
                                                  </div>`
      }
    }
  }

  replaceNumber() {
    this.reset_did = true;
    this.connectedCallback();
  }

  cancel() {
    this.reset_did = false;
    this.connectedCallback();
  }

  validate() {
    let isValid = true;
    let errors = [];
    if(this.pbx_settings.default_campaign == null || this.reset_did) {
      let validateNumber = this.querySelector('pbx-number-picker').validate();
      if(!validateNumber.isValid) {
        if(validateNumber.type == 'none') {
        errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                    <strong>Warning!</strong> Please select number type.
                                                  </div>`;
        } else if (validateNumber.type == 'toll-free') {
        errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                    <strong>Warning!</strong> Please select a toll free prefix.
                                                  </div>`;
        } else if (validateNumber.type == 'local') {
        errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                    <strong>Warning!</strong> Please select a local number prefix.
                                                  </div>`;
        }
        isValid = false;
      }

    
    }

    if(!this.querySelector('.call_treatments_id').value) {
      this.querySelector('.call_treatments_id').classList.add('error');
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> Please select a call treatment.
                                                </div>`;

      isValid = false;
    }
    this.querySelector('.errors').innerHTML = errors;
    return isValid
  }
}

customElements.define('phone-management-setup', PhoneManagementSetup)